import React from "react";
import { useTranslation } from "react-i18next";
import { isEmpty, startCase } from "lodash";
import helpers from "utils/helpers";
import { v4 as uuidv4 } from 'uuid';

const TransactionTable = ({ artistVerification, page, pageSize, activeTab }) => {
  const { t } = useTranslation();

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400 dark:border-[#ffffff38]">
            <tr>
              <th className="px-5 py-3 text-center" scope="col">
                {t("S.NO")}
              </th>
              <th className="px-5 py-3 " scope="col">
                {t("Customer")}
              </th>
              <th className="px-5 py-3 " scope="col">
                {t("Driver")}
              </th>

              <th className="px-5 py-3 text-right" scope="col">
                {t("BOOKING_ID")}
              </th>
              <th className="px-5 py-3 " scope="col">
                {t("TRANSACTION_ID")}
              </th>
              {helpers.andOperator(activeTab == 'tip', <th className="px-5 py-3 text-right" scope="col">
                {t("TIP_AMOUNT")}
              </th>)}
              {helpers.andOperator(activeTab == 'tip', <th className="px-5 py-3 text-right" scope="col">
                {t("STRIPE_TRANSACTION_ID")}
              </th>)}
              {helpers.andOperator(activeTab == 'refund', <th className="px-5 py-3 text-right" scope="col">
                {t("Expected Earning")}
              </th>)}

              {helpers.andOperator(activeTab == 'refund', <th className="px-5 py-3 text-right" scope="col">
                {t("Deduction On Payout")}
              </th>)}

              {helpers.andOperator(activeTab == 'refund', <th className="px-5 py-3 text-right" scope="col">
                {t("Actual Earning")}
              </th>)}

              {helpers.andOperator(activeTab == 'wallet', <>
                <th className="px-5 py-3 text-right" scope="col">
                  {t("ESTIMATED_EARNING")}
                </th>
                <th className="px-5 py-3 text-right" scope="col">
                  {t("ADMIN_COMMISSION")}
                </th>
                <th className="px-5 py-3 text-right" scope="col">
                  {t("ACTUAL_EARNING")}
                </th>
                <th className="px-5 py-3 text-center" scope="col">
                  {t("PAYMENT_METHOD")}
                </th>
              </>)}


              <th className="px-5 py-3 text-center" scope="col">
                {t("STATUS")}
              </th>
              <th scope="col" className="py-3 px-5 text-center">
                {t("O_CREATED_AT")}
              </th>
            </tr>
          </thead>
          <tbody>
            {artistVerification?.map((item, i) => (
              <tr
                key={uuidv4()}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
              >
                <th
                  scope="row"
                  className="py-2 px-4 text-center border-r dark:border-[#ffffff38] font-medium text-gray-900  dark:text-white"
                >
                  {i + 1 + pageSize * (page - 1)}
                </th>
                <td className="py-2 px-4 border-r dark:border-[#ffffff38]">
                  {startCase(item?.userName) || "N/A"}
                </td>
                <td className="py-2 px-4 border-r dark:border-[#ffffff38]">
                  {startCase(item?.driverName) || "N/A"}
                </td>

                <td className="py-2 px-4 border-r text-right dark:border-[#ffffff38]">
                  #{item?.orderId || "N/A"}
                </td>

                <td className="py-2 px-4 border-r dark:border-[#ffffff38]">
                  {item?.transactionID || "N/A"}
                </td>

                {helpers.andOperator(activeTab == 'tip', <td className="py-2 px-4 text-right border-r dark:border-[#ffffff38]">
                  {helpers?.formattedAmount(item?.transactionAmount) || "N/A"}
                </td>)}

                {helpers.andOperator(activeTab == 'tip', <td className="py-2 px-4 text-right border-r dark:border-[#ffffff38]">
                  {item?.paymentIntentId || "N/A"}
                </td>)}

                {helpers.andOperator(activeTab == 'refund', <td className="py-2 px-4 text-right border-r dark:border-[#ffffff38]">
                  {helpers?.formattedAmount(item?.expectedSPEarning) || "N/A"}
                </td>)}

                {helpers.andOperator(activeTab == 'refund', <td className="py-2 px-4 text-right border-r dark:border-[#ffffff38]">
                  {helpers?.formattedAmount(item?.spEarning) || "N/A"}
                </td>)}

                {helpers.andOperator(activeTab == 'refund', <td className="py-2 px-4 text-right border-r dark:border-[#ffffff38]">
                  {helpers?.formattedAmount(item?.expectedSPEarning-item?.spEarning) || "N/A"}
                </td>)}

                {helpers.andOperator(activeTab == 'wallet', <>
                  <td className="py-2 px-4 text-right border-r dark:border-[#ffffff38]">
                    {helpers?.formattedAmount(item?.expectedSPEarning) || "N/A"}
                  </td>

                  <td className="py-2 px-4 text-right border-r dark:border-[#ffffff38]">
                    {helpers?.formattedAmount(item?.adminCommissionFromSP || 0)}
                  </td>

                  <td className="py-2 px-4 text-right border-r dark:border-[#ffffff38]">
                    {helpers?.formattedAmount(item?.spEarning || 0)}
                  </td>
                  <td className="py-2 px-4 border-r dark:border-[#ffffff38] text-center">
                    {helpers?.capitalizeFirstWord(item?.paymentMode)}
                  </td>
                </>)}



                <td className={`py-2 px-4 border-r dark:border-[#ffffff38] text-center ${helpers.getTextColor(item?.status)}`}>
                  {helpers.capitalizeFirstWord(item?.status) || "N/A"}
                </td>

                <td className="py-2 px-4 border-r dark:border-[#ffffff38] text-center">
                  {helpers.getDateAndTime(item?.createdAt)}
                </td>
              </tr>
            ))}
            {isEmpty(artistVerification) ? (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6" colSpan={13}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionTable;
